




import { Component, Vue } from 'vue-property-decorator'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
import cardContainer from '@/common/cardMap/cardLayout/cardContainer.vue'
import cardTable from '@/common/cardMap/cardLayout/cardTable.vue'
import cardTableInfo from '@/common/cardMap/cardLayout/cardTableInfo.vue'
import ioCard from '@/common/cardMap/cardLayout/ioCard.vue'
import outCard from '@/common/cardMap/cardLayout/out-card.vue'
import outPageCom from '@/views/newPension/pensionCard/investCard/coms/outPageCom.vue'
import { FetchIsAllInfo } from '@/api/card/investCard'
import TsTable from '@/components/TsTable/TsTable.vue'
import Earn from '@/views/newPension/pensionCard/investCard/coms/earn.vue'
import { CommonMudule } from '@/store/modules/common'

@Component({
  name: '',
  components: {
    cardContainer,
    cardWraper,
    cardTable,
    cardTableInfo,
    ioCard,
    outCard,
    TsTable,
    Earn,
    outPageCom
  },
})
export default class extends Vue {
  dataObj = {}
  async onFetchIsInfo () {
    const ret = await FetchIsAllInfo({
      customerId: CommonMudule.customerId,
      storyLineType: 'Pension',
    })

    if (ret.statusCode === 0 && ret.data) {
      this.dataObj = ret.data
    }
  }

  created () {
    this.onFetchIsInfo()
  }
}
